import React from 'react'

import { Text } from '@vividseats/vivid-ui-kit'

import styles from './styles.module.scss'

interface Props {
    team1: [string, string]
    team2: [string, string]
}

const teamText = (team: [string, string]) => (
    <>
        <Text className={styles.text} altFont size="sm" weight="bold">
            {team[0]}{' '}
        </Text>
        <Text className={styles.text} altFont size="sm">
            {team[1]}{' '}
        </Text>
    </>
)

const MatchupPill: React.FC<Props> = ({ team1, team2 }) => (
    <div className={styles.badge}>
        {teamText(team1)}
        <Text className={styles.vsText} altFont size="sm">
            vs.{' '}
        </Text>
        {teamText(team2)}
    </div>
)

export default MatchupPill
